module.exports = __webpack_public_path__ + "media/images/svg/youtube-4d240eab0d844917c398727022701bed.svg";